import {
  FormBuilderMetaFlags,
  IWidgetType,
  getWidgetName,
} from '@framework/engine';
import { yup } from '@framework/validation';
import { sum } from 'lodash';
import { FormBuilderMetaFlagExportMetadata } from '../../directives/metadata/MetadataDirective.type';
import { IMapWidget } from './IMapWidget';
import { getComputedTotalCadastralAffectedArea } from './components/computed/MapComputedTotalCadastralAffectedArea';

export const MapCadastralAreaItemSchema = yup
  .object({
    isManual: yup.boolean().default(false).label('Manuale'),
    castralMunicipality: yup.string().required().label('Comune catastale'),
    cadastralSection: yup.string().notRequired().label('Sezione catastale'),
    cadastralSheet: yup.string().required().label('Foglio catastale'),
    cadastralParticle: yup.string().required().label('Particella catastale'),
    // Area
    feature: yup.string().label('Feature GeoJSON'),
    area: yup.number().label('Area'),
    affectedArea: yup.number().required().label('Area interessata'),
    // Competenza
    competence: yup
      .string()
      .notRequired()
      .label('Codice layer vettoriale Competenza'),
  })
  .required();

export type MapCadastralAreaItem = yup.InferType<
  typeof MapCadastralAreaItemSchema
>;

/**
 * Geometria di base.
 */
export const MapGeometryItemSchema = yup.object({
  feature: yup.string().required().label('GeoJSON Feature'),
  id: yup.string().required().label('Id'),
  area: yup.number().required().label('Area'),
});

export type MapGeometryItem = yup.InferType<typeof MapGeometryItemSchema>;

export const MapCadastralSuffix = '@cadastral';
export const MapGeometriesAreaSuffix = '@area';
export const MapCadastralAreaSuffix = '@cadastralArea';

export const createMapSchema: IWidgetType<IMapWidget>['createFormSchema'] = ({
  widget,
  section,
  page,
  parentScope,
}) => {
  const fieldName = getWidgetName(widget);
  const cadastralFieldName = `${fieldName}${MapCadastralSuffix}`;
  const geometriesAreaFieldName = `${fieldName}${MapGeometriesAreaSuffix}`;
  const cadastralAreaFieldName = `${fieldName}${MapCadastralAreaSuffix}`;

  return {
    [fieldName]: yup.array(MapGeometryItemSchema).default([]),
    [cadastralFieldName]: yup
      .array(MapCadastralAreaItemSchema)
      .default([])
      .formBuilderFlags(
        FormBuilderMetaFlags.SkipValidationRules,
        FormBuilderMetaFlags.SkipDefaultValue,
        FormBuilderMetaFlagExportMetadata,
      ),
    [geometriesAreaFieldName]: yup
      .number()
      .when([fieldName], ([items], schema) => {
        const areas = ((items ?? []) as MapGeometryItem[]).map(
          item => item.area,
        );
        return schema.transform((value, originalValue) => sum(areas));
      })
      .formBuilderFlags(
        FormBuilderMetaFlags.SkipValidationRules,
        FormBuilderMetaFlags.SkipDefaultValue,
        FormBuilderMetaFlagExportMetadata,
      ),
    [cadastralAreaFieldName]: yup
      .number()
      .when([cadastralFieldName], ([items], schema) => {
        return schema.transform((value, originalValue) =>
          getComputedTotalCadastralAffectedArea(items),
        );
      })
      .formBuilderFlags(
        FormBuilderMetaFlags.SkipValidationRules,
        FormBuilderMetaFlags.SkipDefaultValue,
        FormBuilderMetaFlagExportMetadata,
      ),
  };
};
